import { bool, func } from "prop-types";
import ShareIcons from "../../../../../Common/js/components/ShareIcons/ShareIcons.jsx";
import { CopyToClipboard } from "react-copy-to-clipboard";
import cx from "classnames";

const propTypes = { displayShare: bool, onCopy: func };

const ShareBox = (props) => {
  const { displayShare, shareRef, onCopy } = props;

  return (
    <div
      className={cx("share-box", {
        "share-box--active": displayShare,
      })}
      ref={shareRef}
    >
      <label>
        <div className="share-box__share-title">Share link to page</div>
        <input
          readOnly
          value={window.location.href}
          className="share-box__share-input sc-form-item__field"
        />
      </label>
      <div className="share-box__share-lower">
        <ShareIcons />
        <div className="share-box__share-copy-container">
          <CopyToClipboard text={window.location.href} onCopy={onCopy}>
            <button className="share-box__share-copy-btn" type="button">
              Copy Url
            </button>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

ShareBox.propTypes = propTypes;
export default ShareBox;
